<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFinalizarPeriodo" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          <v-icon left color="warning">mdi-alert-circle</v-icon>
          Confirmar Finalização de Período
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Deseja realmente finalizar o período de
            <strong>{{ selectedStartDate }}</strong> a
            <strong>{{ selectedEndDate }}</strong> para a(s) empresa(s):
          </div>
          <div class="mt-3 text-body-1">
            <strong>{{
              selectedCompany ? selectedCompany.replace(",", "") : ""
            }}</strong>
          </div>
          <div class="mt-3 text-body-2 grey--text">
            Esta ação não poderá ser desfeita.
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn
            text
            @click="dialogFinalizarPeriodo = false"
            :disabled="loadingFinalizarPeriodo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="confirmarFinalizarPeriodo"
            :loading="loadingFinalizarPeriodo"
          >
            <v-icon left>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReabrirPeriodo" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          <v-icon left color="error">mdi-lock-open-variant</v-icon>
          Confirmar Reabertura de Período
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Deseja realmente reabrir o período de
            <strong>{{ selectedStartDate }}</strong> a
            <strong>{{ selectedEndDate }}</strong> para a empresa:
          </div>
          <div class="mt-3 text-body-1">
            <strong>{{
              selectedCompany ? selectedCompany.replace(",", "") : ""
            }}</strong>
          </div>
          <div class="mt-3 text-body-2 error--text">
            <v-icon small color="error">mdi-alert</v-icon>
            Esta ação irá deletar o lote finalizado e permitirá refinalização.
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn
            text
            @click="dialogReabrirPeriodo = false"
            :disabled="loadingReabrirPeriodo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            @click="confirmarReabrirPeriodo"
            :loading="loadingReabrirPeriodo"
          >
            <v-icon left>mdi-lock-open-variant</v-icon>
            Reabrir Período
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-component
          :opcoes="opcoes"
          :produtos="tipos_funerarios"
          :modos="modos"
          :tipos="tipos"
          :calendar="'mes'"
          @filtrar="filterData"
          @showError="showError = true"
          :title_opcao="'Campanha'"
          :campos="'N'"
        ></filtro-component>
      </v-col>
    </v-container>

    <v-row class="ml-4">
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="rgb(71 130 180)"
          icon="mdi-cash"
          title="Renegociado"
          sub-icon-color="red"
          :valuex="false"
          :value="formatarMoeda(this.total_renegociado)"
          :sub-text="
            'Descontos aplicados: ' +
            formatarMoeda(this.total_renegociado - this.total_pago)
          "
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="rgb(71 130 180)"
          icon="mdi-cash"
          title="Recebido"
          sub-icon-color="red"
          :valuex="false"
          :value="formatarMoeda(this.total_pago)"
          :sub-text="'Total Recebido'"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="rgb(71 130 180)"
          icon="mdi-cash"
          title="Comissão de Acordos"
          sub-icon-color="red"
          :valuex="false"
          :value="formatarMoeda(this.total_pago_comissao)"
          :sub-text="'Total Pago com Comissão '"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3" v-if="loteFinalizado">
        <base-material-lote-card
          color="rgb(71 130 180)"
          icon="mdi-lock-check"
          title="Período Finalizado"
          :competencia="loteFinalizado.competencia"
          :empresa="loteFinalizado.empresa"
          :finalizadoPor="loteFinalizado.insertBy || 'Sistema'"
          :dataFinalizacao="loteFinalizado.data_insert"
          :valorTotal="formatarMoeda(loteFinalizado.valorTotal || 0)"
          :quantidadeColaboradores="loteFinalizado.quantidadeColaboradores || 0"
          :showReopenButton="podeReabrirPeriodo"
          @reabrir-click="abrirDialogReabrirPeriodo"
        />
      </v-col>
    </v-row>

    <br />

    <v-divider></v-divider>

    <br /><br />

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-percent"
            title="Comissão"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="ranking_header"
              :items="lista_comissao_grupo"
              :items-per-page="20"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      width: 32%;
                      font-size: 11px;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    <v-icon color="black" size="24" class="ml-2 mr-1">
                      <template v-if="row.item.tipo === 'OPERADOR (A)'">
                        mdi-headset
                      </template>

                      <template
                        v-else-if="
                          row.item.tipo === 'MOTOBOY' ||
                          row.item.tipo === 'MotoGirl'
                        "
                      >
                        mdi-motorbike
                      </template>

                      <template
                        v-else-if="
                          row.item.tipo && row.item.tipo.toUpperCase().includes('SUPERVISOR')
                        "
                      >
                        mdi-account-supervisor
                      </template>

                      <template
                        v-else-if="
                          row.item.tipo && [
                            'GERÊNCIA ADJUNTA',
                            'GERÊNCIA UNIDADE',
                            'GERÊNCIA',
                          ].some((type) =>
                            row.item.tipo.toUpperCase().includes(type),
                          )
                        "
                      >
                        mdi-account-supervisor
                      </template>

                      <template
                        v-else-if="row.item.profissao === 'Supervisor (a)'"
                      >
                        mdi-account-supervisor
                      </template>

                      <template
                        v-else-if="row.item.tipo && row.item.tipo.toUpperCase().includes('LOJA')"
                      >
                        mdi-storefront
                      </template>

                      <template
                        v-else-if="
                          row.item.tipo && (row.item.tipo.toUpperCase().includes('AUXILIAR') ||
                          row.item.tipo.toUpperCase().includes('ASSISTENTE'))
                        "
                      >
                        mdi-account-tie
                      </template>
                    </v-icon>

                    {{ row.item.usuario ? row.item.usuario.toUpperCase() : '' }}
                  </td>
                  <td class="linha" style="width: 12%; font-size: 14px">
                    {{ row.item.tipo ? row.item.tipo.toUpperCase() : '' }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    <v-chip
                      :color="getStatus(row.item.empresa)"
                      text-color="white"
                    >
                      {{ row.item.empresa }}
                    </v-chip>
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{
                      parseFloat(row.item.renegociado).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{
                      parseFloat(row.item.original).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>

                  <td
                    class="linha"
                    style="width: 8%; font-size: 14px"
                    :title="
                      row.item.empresa === 'PREVIDA'
                        ? 'Total dentro da regra: ' +
                          parseFloat(
                            row.item.pagoDentroRegras || 0,
                          ).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })
                        : undefined
                    "
                  >
                    {{
                      parseFloat(row.item.pago).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>

                  <td class="linha" style="width: 4%; font-size: 14px">
                    {{ row.item.percentual }}
                  </td>

                  <td class="linha">
                    {{
                      parseFloat(row.item.comissao).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </template>
            </v-data-table>

            <br />

            <div class="d-flex justify-space-between align-center">
              <div v-if="lista_comissao_grupo.length > 0 && !loteFinalizado">
                <v-btn
                  color="primary"
                  elevation="2"
                  @click="abrirDialogFinalizarPeriodo"
                >
                  <v-icon left>mdi-calendar-check</v-icon>
                  Finalizar Período
                </v-btn>
              </div>
              <div v-else></div>

              <div class="d-flex justify-end">
                <div style="width: 240px">
                  <span
                    @click="download_alelo_xls"
                    style="
                      color: orange;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-gift"></i>
                  </span>

                  <span
                    @click="download_xls"
                    style="
                      color: green;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-file-excel"></i>
                  </span>

                  <span
                    @click="exportToPDF"
                    style="
                      color: red;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-file-pdf"></i>
                  </span>

                  <br />
                </div>
              </div>
            </div>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroGeral.vue"; // Certifique-se de que o caminho esteja correto
import Comissao from "../../services/comissao";
import { ContentLoader } from "vue-content-loader";
import jsPDF from "jspdf";
import "jspdf-autotable";
import BaseMaterialLoteCard from "../../components/base/MaterialLoteCard.vue";

export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
    BaseMaterialLoteCard,
  },

  created() {
    (this.selectedStartDate = this.getFirstDayOfMonth()),
      (this.selectedEndDate = this.formatDateBR(new Date()));

    (this.selectedStartDate2 = this.getFirstDayOfMonth()),
      (this.selectedEndDate2 = this.formatDateBR(new Date()));
  },

  // mounted() {
  //   this.carregarLoad(), this.dashboard();
  //   this.handleFilterChange(
  //     this.selectMode,
  //     this.selectedStartDate,
  //     this.selectedEndDate,
  //     this.selectedStartDate2,
  //     this.selectedEndDate2
  //   );
  // },

  data() {
    return {
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
      ranking_header: [
        { text: "Usuário", value: "usuario" },
        { text: "Tipo", value: "tipo" },

        { text: "Empresa", value: "empresa" },
        { text: "Renegociado", value: "renegociado" },
        { text: "Original", value: "original" },
        { text: "Recebido", value: "pago" },
        { text: "%", value: "percentual" },
        { text: "Comissão", value: "comissao" },
      ],

      lista_comissao: [],
      lista_comissao_grupo: [],
      produto: "Todos",
      bool_03: true,
      bool_02: true,
      total_resultado: 0,
      total_pago_comissao: 0,
      total_pago: 0,
      total_renegociado: 0,

      total_pago_pre: 0,
      total_pago_par: 0,
      total_pago_mem: 0,
      total_pago_ver: 0,
      total_pago_am: 0,

      subTextAddDynamic: "Total Recebido:",
      recebido_acordo: 0,
      qtd_recebido_acordo: 0,
      criado_acordo: 0,
      animationInterval: null, // Intervalo para controlar a animação
      empresa: "Todas",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      opcoes: ["Todas", "Campanha 50 Anos"],
      selectMode: "Pagamento",
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      modos: ["Período"],
      modos2: ["SIM", "NÃO"],
      campos: "N",
      categoria: [],
      showFilter: false,
      showError: false,
      showProgress: false,
      showFilterDownload: false,
      dialogFinalizarPeriodo: false,
      loadingFinalizarPeriodo: false,
      dialogReabrirPeriodo: false,
      loadingReabrirPeriodo: false,
      loteFinalizado: null,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Todos"],
      tipos_funerarios: ["Todos"],

      lista_nome_empresa: [],
    };
  },

  computed: {
    podeReabrirPeriodo() {
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      const roles = user.roles || [];
      return (
        roles.includes("ROLE_ADMIN") || roles.includes("ROLE_COMISSAO_REABRIR")
      );
    },
  },

  methods: {
    isDateValid(dateString) {
      // Verifica se a string é uma data válida
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    areDatesValid(dates) {
      // Verifica se todas as datas na matriz são válidas
      return dates.every((dateString) => {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
      });
    },

    handleFilterChange(selectedFilter, dataI, dataF, DataRI, DataRF) {
      if (selectedFilter === "Vencimento") {
        this.subTextAddDynamic = "Total Recebido: ";
      } else if (selectedFilter != "Vencimento") {
        if (
          converteDataParaFormatoISO(DataRI) <=
            converteDataParaFormatoISO(dataI) &&
          converteDataParaFormatoISO(DataRF) > converteDataParaFormatoISO(dataF)
        ) {
          this.subTextAddDynamic = "Total Recebido com Acréscimo: ";
        } else {
          this.subTextAddDynamic = "Total Recebido: ";
        }
      }
    },

    async filterData(valores) {
      this.carregarLoad(), (this.isLoading = true);
      let nova_consulta = false;

      this.selectedType =
        valores.selectedType === "Jazigo" ? "Cemitérios" : valores.selectedType;
      this.selectedOpcao = valores.selectedOpcao;
      this.selectedCompany = valores.selectedCompany.join(",");
      this.selectMode = valores.selectMode;
      this.selectMode = "Pagamento";

      this.handleFilterChange(
        valores.selectMode,
        valores.selectedStartDate,
        valores.selectedEndDate,
        valores.selectedStartDate2,
        valores.selectedEndDate2,
      );
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedStartDate2 = valores.selectedStartDate2;
      this.selectedEndDate2 = valores.selectedEndDate2;
      this.selectedStartDate3 = valores.selectedStartDate3;
      this.selectedEndDate3 = valores.selectedEndDate3;
      this.produto = valores.selectedProduto;

      if (
        this.selectedCompany &&
        this.selectedCompany.includes("PREVIDA") &&
        !/CEMIT[EÉ]RIO/i.test(this.selectedCompany)
      ) {
        // Verificar se periodo anterior está finalizado
        const periodoAnteriorFinalizado =
          await this.verificarLoteFinalizadoAnterior();

        if (!periodoAnteriorFinalizado) {
          // Calcular o mês anterior para exibir na mensagem
          const [dia, mes, ano] = this.selectedStartDate.split("/");
          const mesAtual = parseInt(mes);
          const anoAtual = parseInt(ano);

          let mesAnterior = mesAtual - 1;
          let anoAnterior = anoAtual;

          if (mesAnterior === 0) {
            mesAnterior = 12;
            anoAnterior = anoAtual - 1;
          }

          const competenciaAnterior = `${String(mesAnterior).padStart(
            2,
            "0",
          )}/${anoAnterior}`;

          this.showSnackbar(
            `O período anterior (${competenciaAnterior}) não foi finalizado. Finalize o período anterior antes de consultar este período.`,
            "warning",
            6000,
          );
          this.isLoading = false;
          return;
        }
      }
      // Verificar se existe lote finalizado
      await this.verificarLoteFinalizado();

      //this.gf01();
      this.dashboard();
    },

    consultarConformidades() {
      try {
        const data = this.selectedEndDate;
        const [, mes, ano] = data.split("/");
        const periodo = `${mes}-${ano}`;

        const response = Comissao.lista_conformidade_filtro(
          periodo,
          "Cobrança",
          this.selectedCompany,
        );
        return response;
      } catch (error) {
        console.error("Erro ao consultar conformidades:", error);
      }
    },

    async exportToPDF() {
      const doc = new jsPDF("landscape", "pt", "a4"); // Define a orientação da página como paisagem e tamanho A4
      const usuario = JSON.parse(sessionStorage.getItem("user")).nome;

      const logoY = 15; // Posição Y da logo
      const logoWidth = 150; // Largura da logo
      const logoHeight = 80; // Altura da logo
      const titleY = 35; // Posição inicial para o título
      const periodY = titleY + 20; // Posição para o período
      const maxLinesPerPage = 18; // Limite de linhas por página

      // Preparar informações de rodapé
      const now = new Date();
      const formattedDate = now.toLocaleDateString("pt-BR");
      const formattedTime = now.toLocaleTimeString("pt-BR");
      const dateTimeString = `Data e Hora de Criação: ${formattedDate} ${formattedTime}`;

      // Determinar logo baseado na empresa selecionada
      const logoPath = this.determinarLogo(this.selectedCompany);

      // Cabeçalhos da tabela
      const headers = this.ranking_header.map((header) => header.text);

      // Dados da tabela
      const filteredData = this.lista_comissao_grupo
        .filter((item) => parseFloat(item.comissao || 0) > 0) // Filtra itens onde a comissão é maior que 0
        .map((item) =>
          this.ranking_header.map((header) => {
            let value = item[header.value]; // Define 'value' com o valor do item

            if (
              header.value === "original" ||
              header.value === "pago" ||
              header.value === "comissao" ||
              header.value === "renegociado"
            ) {
              return parseFloat(value || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            } else if (header.value === "tipo") {
              return value ? value.toUpperCase() : ""; // Aplica toUpperCase() em profissao
            }

            return value !== null && value !== undefined ? value : "";
          }),
        );

      let startY = periodY + 40; // Posição Y inicial para a tabela (abaixo do período)
      let pageCount = 0;

      const addTableToPDF = (data, isFirstPage) => {
        doc.autoTable({
          startY: startY,
          head: [headers],
          body: data,
          theme: "grid",
          headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
          columnStyles: { 0: { cellWidth: "auto" } },
          margin: { bottom: 60 },
          didDrawPage: (data) => {
            // Adicionar logo no topo de cada página
            if (logoPath) {
              try {
                doc.addImage(logoPath, "PNG", 20, logoY, logoWidth, logoHeight);
              } catch (error) {
                console.error("Erro ao adicionar logo:", error);
              }
            }

            // Adiciona o título e o período na parte superior de cada página
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text(
              "Comissão de Acordos",
              doc.internal.pageSize.width / 2,
              titleY,
              { align: "center" },
            );

            doc.setFontSize(12);
            doc.setFont("helvetica", "normal");
            doc.text(
              "Período: " +
                this.selectedStartDate +
                " até " +
                this.selectedEndDate,
              doc.internal.pageSize.width / 2,
              periodY,
              { align: "center" },
            );

            // Adicionar rodapé em cada página
            const pageHeight = doc.internal.pageSize.height;
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text(dateTimeString, 20, pageHeight - 30);
            doc.text("Usuário: " + usuario, 20, pageHeight - 15);
          },
        });
      };

      // Processa os dados em blocos de até 20 linhas por página
      for (let i = 0; i < filteredData.length; i += maxLinesPerPage) {
        const pageData = filteredData.slice(i, i + maxLinesPerPage);
        const isFirstPage = i === 0; // Verifica se é a primeira página

        addTableToPDF(pageData, isFirstPage);

        startY = doc.autoTable.previous.finalY + 20; // Ajusta a posição Y para o rodapé

        // Se não for a última página e houver mais dados, adicione uma nova página
        if (i + maxLinesPerPage < filteredData.length) {
          doc.addPage();
          startY = periodY + 40; // Mesma posição inicial da primeira página
          pageCount++;
        }
      }

      // Adicionar rótulo e valor do total pago na última página
      const totalPagoY = startY + 20;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Total Pago:", 20, totalPagoY); // Adiciona o rótulo

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(
        parseFloat(this.total_pago_comissao || 0).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
        100, // Posição x do valor
        totalPagoY, // Posição y do valor
      );

      // Consultar ocorrências usando o método consultarConformidades
      try {
        const response = await this.consultarConformidades();
        const itensOcorrencia = response.data || [];

        if (itensOcorrencia.length > 0) {
          // Cabeçalhos específicos para a tabela de ocorrências
          const ocorrenciaHeaders = [
            "Colaborador",
            "Empresa",
            "Comissão",
            "Tipo",
            "Observação",
            "Criado por",
          ];

          // Formatar os dados de ocorrência para a tabela com apenas os campos específicos
          const ocorrenciaData = itensOcorrencia.map((item) => [
            item.pessoa || "", // Colaborador/Usuário
            item.empresa || "", // Empresa
            parseFloat(item.valor || 0).toLocaleString("pt-BR", {
              // Valor (comissão)
              style: "currency",
              currency: "BRL",
            }),
            item.tipo || "", // Tipo
            item.obs || "", // Observação
            item.user_insert || "", // Criado por
          ]);

          // Verificar se há espaço suficiente na página atual
          const pageHeight = doc.internal.pageSize.height;
          const footerSpace = 60; // Espaço reservado para o rodapé
          const minSpaceNeeded = 100; // Espaço mínimo necessário para título + algumas linhas da tabela
          const ocorrenciaTitleY = totalPagoY + 40;

          // Se não houver espaço suficiente, criar nova página
          if (ocorrenciaTitleY + minSpaceNeeded > pageHeight - footerSpace) {
            doc.addPage();
            const newOcorrenciaTitleY = periodY + 40; // Começar após o cabeçalho padrão

            doc.setFontSize(12);
            doc.setFont("helvetica", "bold");
            doc.text("Ocorrências", 20, newOcorrenciaTitleY);

            // Adicionar tabela de ocorrências na nova página
            doc.autoTable({
              startY: newOcorrenciaTitleY + 10,
              head: [ocorrenciaHeaders],
              body: ocorrenciaData,
              theme: "grid",
              headStyles: {
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
              },
              columnStyles: { 0: { cellWidth: "auto" } },
              margin: { bottom: 60 },
              didDrawPage: (data) => {
                // Adicionar logo e cabeçalho na nova página
                if (logoPath) {
                  try {
                    doc.addImage(
                      logoPath,
                      "PNG",
                      20,
                      logoY,
                      logoWidth,
                      logoHeight,
                    );
                  } catch (error) {
                    console.error("Erro ao adicionar logo:", error);
                  }
                }

                doc.setFontSize(16);
                doc.setFont("helvetica", "bold");
                doc.text(
                  "Comissão de Acordos",
                  doc.internal.pageSize.width / 2,
                  titleY,
                  { align: "center" },
                );

                doc.setFontSize(12);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Período: " +
                    this.selectedStartDate +
                    " até " +
                    this.selectedEndDate,
                  doc.internal.pageSize.width / 2,
                  periodY,
                  { align: "center" },
                );

                // Adicionar rodapé
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.text(dateTimeString, 20, pageHeight - 30);
                doc.text("Usuário: " + usuario, 20, pageHeight - 15);
              },
            });
          } else {
            // Há espaço suficiente na página atual
            doc.setFontSize(12);
            doc.setFont("helvetica", "bold");
            doc.text("Ocorrências", 20, ocorrenciaTitleY);

            // Adicionar tabela de ocorrências
            doc.autoTable({
              startY: ocorrenciaTitleY + 10,
              head: [ocorrenciaHeaders],
              body: ocorrenciaData,
              theme: "grid",
              headStyles: {
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
              },
              columnStyles: { 0: { cellWidth: "auto" } },
              margin: { bottom: 60 },
            });
          }
        }
      } catch (error) {
        console.error("Erro ao obter ocorrências:", error);
      }

      // Salvar o PDF
      doc.save(this.selectedStartDate + "_lista_comissao.pdf");
    },
    determinarLogo(empresa) {
      empresa = empresa.replace(",", "");
      try {
        switch (empresa) {
          case "PREVIDA":
            return require("@/assets/logo_previda.png");
          case "PARQUE DAS FLORES":
            return require("@/assets/parque_logo.png");
          case "PARQUE DO AGRESTE":
            return require("@/assets/am_logo.png");
          case "MEMORIAL PARQUE MACEIÓ":
            return require("@/assets/memorial_logo.png");
          case "CEMITERIO PREVIDA":
            return require("@/assets/versan_logo.png");
          default:
            return require("@/assets/logo_grupo.png");
        }
      } catch (error) {
        console.error("Erro ao carregar logo:", error);
        return null;
      }
    },

    filtrarTiposFunerarios(tipoFunerario) {
      let tiposPermitidos = ["Todos"]; // Sempre inicialize como array
      if (this.tipoFunerario === "Jazigo") {
        tiposPermitidos = [
          "CONCESSÃO DE COLUMBÁRIO",
          "CONCESSÃO DE JAZIGOS",
          "CONCESSÃO DE OSSÁRIO",
          "VENDA DE COLUMBÁRIO",
          "VENDA DE JAZIGOS - IMEDIATO",
          "VENDA DE JAZIGOS - PREVENTIVO",
          "VENDA DE JAZIGOS - TRANSITÓRIO",
        ];
      }
      if (this.tipoFunerario === "Plano") {
        tiposPermitidos = [
          "COMPLETO",
          "FAMILIA",
          "INTEGRAL",
          "P23",
          "TOTAL",
          "PF - AMPARO",
          "PROTEÇÃO",
          "PV - AMIGO",
          "PV - BRONZE",
          "PV - CREMAÇÃO COM CERIMÔNIA",
          "PV - DIAMANTE",
          "PV - EMPRESARIAL",
          "PV - EMPRESARIAL - EMPRESA",
          "PV - ESPECIAL",
          "PV - ESMERALDA",
          "PV - ESSENCIAL",
          "PV - IDEAL",
          "PV - MAIOR",
          "PV - MAIS",
          "PV - MASTER GOLD",
          "PV - MELHOR",
          "PV - PLANO PJ",
          "PV - PLUS",
          "PV - POLICIA MILITAR",
          "PV - PRATA",
          "PV - PREVIDA",
          "PV - PREVIPARQ DO AGRESTE",
          "PV - RUBI",
          "PV - SÃO MATHEUS",
        ];
      }

      if (this.tipoFunerario === "Cremação") {
        tiposPermitidos = [
          "CREMAÇÃO",
          "CREMAÇÃO COM CERIMÔNIA",
          "CREMAÇÃO SEM CERIMÔNIA",
          "URNAS CINERARIAS",
        ];
      }

      if (
        this.tipoFunerario === "Todos" ||
        this.tipoFunerario === "Funerária" ||
        this.tipoFunerario === "Serviços Administrativos e Cemiteriais" ||
        this.tipoFunerario === "Serviços Cemiteriais"
      ) {
        tiposPermitidos = ["Todos"];
      }

      if (
        Array.isArray(tiposPermitidos) &&
        tiposPermitidos.includes(tipoFunerario)
      ) {
        return true; // Mantém apenas os tipos permitidos
      } else {
        return false; // Remove os tipos não permitidos
      }
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1,
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    startAnimation(targetValue) {
      this.animationInterval = setInterval(() => {
        if (this.animatedValue < targetValue) {
          this.animatedValue += 1; // Atualiza o valor animado
        } else {
          clearInterval(this.animationInterval); // Interrompe a animação quando atingir o valor desejado
        }
      }, 10); // Intervalo em milissegundos entre cada atualização
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateBRAPI(date) {
      if (!date) return "";
      const parsedDate = new Date(this.formatDateBR(date));
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      return `${year}-${month}-${day}`;
    },

    carregarLoad() {
      this.bool_03 = true;
      this.bool_03 = true;
    },

    async dashboard() {
      this.isLoading = true;

      this.selectMode = "Vencimento";
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      const formattedStartDate2 = converteDataParaFormatoISO(
        this.selectedStartDate2,
      );
      const formattedEndDate2 = converteDataParaFormatoISO(
        this.selectedEndDate2,
      );

      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 365) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 365;
        return;
      }

      Comissao.lista_comissao(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            this.lista_comissao = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.calcularDadosPorUsuario();
          this.isLoading = false;
        });
    },

    download_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 60) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 60;
        return;
      }

      Comissao.lista_comissao_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            const fileName = `comissao_${Date.now()}.xlsx`;
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },

    download_alelo_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 60) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 60;
        return;
      }

      Comissao.lista_comissao_alelo_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            const fileName = `comissao_${Date.now()}.xlsx`;
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },

    calcularDadosPorUsuario() {
      const dadosPorUsuario = {};
      this.lista_comissao_grupo = "";
      this.total_pago_comissao = 0;
      this.total_pago = 0;
      this.total_renegociado = 0;

      (this.total_pago_pre = 0),
        (this.total_pago_par = 0),
        (this.total_pago_mem = 0),
        (this.total_pago_ver = 0),
        (this.total_pago_am = 0),
        (this.total_resultado = 0);

      this.lista_comissao.forEach((item) => {
        if (item.excecao === true) {
          return;
        }
        
        // Limpar CPF (remover pontos e traços) e usar como chave de agrupamento
        const cpfLimpo = item.cpf_vendedor ? item.cpf_vendedor.replace(/[.-]/g, '') : null;
        const chave = cpfLimpo || item.usuario;
        
        if (!dadosPorUsuario.hasOwnProperty(chave)) {
          dadosPorUsuario[chave] = {
            comissao: 0,
            empresa: "",
            original: 0,
            renegociado: 0,
            pago: 0,
            pagoDentroRegras: 0,
            resultado: 0,
            comissaofinal: 0,
          };
        }

        dadosPorUsuario[chave].comissao += item.comissao;
        
        // Pegar o nome mais completo (maior length)
        if (!dadosPorUsuario[chave].usuario || item.usuario.length > dadosPorUsuario[chave].usuario.length) {
          dadosPorUsuario[chave].usuario = item.usuario;
        }

        if (item.tipo !== "" && item.tipo != null) {
          dadosPorUsuario[chave].tipo = item.tipo;
        }

        dadosPorUsuario[chave].empresa = item.empresa;
        dadosPorUsuario[chave].total = item.total;
        dadosPorUsuario[chave].ref = item.ref;
        dadosPorUsuario[chave].original += item.orginal;

        if (item.tipo_acordo == 19) {
          dadosPorUsuario[chave].renegociado += item.orginal;
        } else {
          dadosPorUsuario[chave].renegociado += item.pago;
        }

        if (item.tipo !== "" && item.tipo != null) {
          const percentualAtual = dadosPorUsuario[chave].percentual;

          // Primeira atribuição
          if (percentualAtual == null) {
            dadosPorUsuario[chave].percentual = item.percentual;
          }
          // Substitui somente se o atual for 0% e o novo não for 0%
          else if (percentualAtual === "0%" && item.percentual !== "0%") {
            dadosPorUsuario[chave].percentual = item.percentual;
          }
        }

        dadosPorUsuario[chave].pago += item.pago;
        if (
          !(item.obs && item.obs.trim().startsWith("RENEG COM DOCUMENTO MENOR"))
        ) {
          dadosPorUsuario[chave].pagoDentroRegras += item.pago;
        }
        dadosPorUsuario[chave].resultado += item.resultado;
        dadosPorUsuario[chave].resultado += item.conformidade;

        const vl = this.calcularComissao(
          item.empresa,
          item.resultado,
          item.comissao,
          item.orginal,
          item.pago,
        );
        this.total_pago_comissao += vl;

        if (item.tipo !== "MOTOBOY") {
          this.total_pago += item.pago_recebimento;

          if (item.tipo_acordo == 19) {
            this.total_renegociado += item.orginal;
          } else {
            this.total_renegociado += item.pago;
          }

          if (item.empresa == "PREVIDA") {
            this.total_pago_pre += item.pago;
          }
          if (item.empresa == "PARQUE DAS FLORES") {
            this.total_pago_par += item.pago;
          }
          if (item.empresa == "MEMORIAL PARQUE MACEIÓ") {
            this.total_pago_mem += item.pago;
          }
          if (item.empresa == "CEMITÉRIO PREVIDA") {
            this.total_pago_ver += item.pago;
          }
          if (item.empresa == "PARQUE DO AGRESTE") {
            this.total_pago_am += item.pago;
          }
        }

        this.total_resultado += item.resultado;

        dadosPorUsuario[chave].comissaofinal += vl;
        /*

              if((item.tipo == 'SUPERVISOR (A)' || item.tipo == 'GERÊNCIA') && item.empresa == "PARQUE DAS FLORES"){
                  const vl_extra = this.total_pago * 0.01;
                  dadosPorUsuario[item.usuario].comissaofinal = vl_extra;
                  dadosPorUsuario[item.usuario].comissao = vl_extra;
                  this.total_pago_comissao += vl_extra;
              }

              if((item.tipo == 'SUPERVISOR (A)' || item.tipo == 'GERÊNCIA') && item.empresa == "MEMORIAL PARQUE MACEIÓ"){
                  const vl_extra = this.total_pago * 0.01;
                  dadosPorUsuario[item.usuario].comissaofinal = vl_extra;
                  dadosPorUsuario[item.usuario].comissao = vl_extra;
                  this.total_pago_comissao += vl_extra;
              }


              if((item.tipo == 'SUPERVISOR (A)' || item.tipo == 'GERÊNCIA') && item.empresa == "PARQUE DO AGRESTE"){
                  const vl_extra = this.total_pago * 0.02;
                  dadosPorUsuario[item.usuario].comissaofinal = vl_extra;
                  dadosPorUsuario[item.usuario].comissao = vl_extra;

                  this.total_pago_comissao += vl_extra;
              }


              if((item.tipo == 'SUPERVISOR (A)' || item.tipo == 'GERÊNCIA') && item.empresa == "CEMITERIO PREVIDA"){
                  const vl_extra = this.total_pago * 0.01;
                  dadosPorUsuario[item.usuario].comissaofinal = vl_extra;
                  dadosPorUsuario[item.usuario].comissao = vl_extra;

                  this.total_pago_comissao += vl_extra;
              }
                  */
      });

      this.lista_comissao_grupo = Object.values(dadosPorUsuario); // Alteração aqui para referenciar a variável local
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getStatus(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularComissao: function (empresa, resultado, comissao, original, pago) {
      if (empresa === "PREVIDA") {
        if (resultado < 0) {
          // Se o resultado for negativo, retorna a diferença entre pago e original
          //return pago - original;
          return comissao;
        } else {
          // Se o resultado não for negativo, retorna a comissão
          return comissao;
        }
      } else {
        // Se a empresa for diferente de "Previda", retorna a comissão
        return comissao;
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },

    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },

    abrirDialogFinalizarPeriodo() {
      if (!this.selectedCompany || this.selectedCompany === "Todas") {
        this.showError = true;
        return;
      }

      if (!this.selectedStartDate || !this.selectedEndDate) {
        this.showSnackbar("Por favor, selecione um período.", "warning");
        return;
      }

      this.dialogFinalizarPeriodo = true;
    },
    async verificarLoteFinalizadoAnterior() {
      if (!this.selectedCompany || this.selectedCompany === "Todas") {
        return true;
      }

      if (!this.selectedStartDate || !this.selectedEndDate) {
        return true;
      }

      try {
        // Calcular o mês anterior
        const [dia, mes, ano] = this.selectedStartDate.split("/");
        const mesAtual = parseInt(mes);
        const anoAtual = parseInt(ano);

        let mesAnterior = mesAtual - 1;
        let anoAnterior = anoAtual;

        if (mesAnterior === 0) {
          mesAnterior = 12;
          anoAnterior = anoAtual - 1;
        }

        const competenciaAnterior = `${String(mesAnterior).padStart(
          2,
          "0",
        )}/${anoAnterior}`;

        const response = await Comissao.buscarLoteIncluindoTodos(
          competenciaAnterior,
          "ACORDOS",
          this.selectedCompany,
        );

        // Se encontrou o lote do mês anterior, significa que está finalizado
        if (response.data) {
          return true;
        } else {
          // Não encontrou lote finalizado do mês anterior
          return false;
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Não encontrou lote finalizado do mês anterior
          return false;
        } else {
          console.error("Erro ao verificar lote finalizado anterior:", error);
          // Em caso de erro, permitir continuar
          return true;
        }
      }
    },
    async verificarLoteFinalizado() {
      if (!this.selectedStartDate || !this.selectedEndDate) {
        this.loteFinalizado = null;
        return;
      }

      try {
        const [dia, mes, ano] = this.selectedStartDate.split("/");
        const competencia = `${mes}/${ano}`;
        const empresa = this.selectedCompany.replace(",", "");
        const tipo = "ACORDOS";

        const response = await Comissao.buscarLote(competencia, tipo, empresa);
        this.loteFinalizado = response.data;
      } catch (error) {
        this.loteFinalizado = null;
      }
    },

    abrirDialogReabrirPeriodo() {
      this.dialogReabrirPeriodo = true;
    },

    async confirmarReabrirPeriodo() {
      if (!this.podeReabrirPeriodo) {
        this.showSnackbar(
          "Você não tem permissão para reabrir períodos.",
          "error",
        );
        return;
      }

      this.loadingReabrirPeriodo = true;

      try {
        const [dia, mes, ano] = this.selectedStartDate.split("/");
        const competencia = `${mes}/${ano}`;
        const empresa = this.selectedCompany.replace(",", "");
        const tipo = "ACORDOS";

        await Comissao.reabrirPeriodo(competencia, tipo, empresa);

        this.loadingReabrirPeriodo = false;
        this.dialogReabrirPeriodo = false;
        this.loteFinalizado = null;

        this.showSnackbar("Período reaberto com sucesso!", "success");
      } catch (error) {
        this.loadingReabrirPeriodo = false;
        console.error("Erro ao reabrir período:", error);

        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao reabrir período. Tente novamente.",
          "error",
        );
      }
    },

    async confirmarFinalizarPeriodo() {
      this.loadingFinalizarPeriodo = true;

      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      Comissao.finalizarPeriodo(
        this.selectedCompany,
        formattedStartDate,
        formattedEndDate,
        "ACORDOS",
      )
        .then(async (response) => {
          this.loadingFinalizarPeriodo = false;
          this.dialogFinalizarPeriodo = false;
          this.showSnackbar("Período finalizado com sucesso!", "success");
          await this.verificarLoteFinalizado();
        })
        .catch((error) => {
          this.loadingFinalizarPeriodo = false;
          console.error("Erro ao finalizar período:", error);

          if (error.response && error.response.status === 403) {
            const errorMessage = error.response.data;
            if (
              typeof errorMessage === "string" &&
              errorMessage.startsWith(
                "Você não tem permissão para finalizar comissões do tipo:",
              )
            ) {
              this.showSnackbar(errorMessage, "error", 5000);
              return;
            }
          }

          this.showSnackbar(
            "Erro ao finalizar período. Tente novamente.",
            "error",
          );
        });
    },

    formatarMoeda(valor) {
      if (!valor && valor !== 0) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    },
  },
};

function formatMoeda(value) {
  // Use o método toLocaleString com a opção style: 'currency' para formatar como moeda

  if (value === undefined || value === null) {
    return "R$ 0,00"; // Ou você pode retornar 0 como número, se preferir.
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  //return 0
  //return value
}

function converteDataParaFormatoISO(dataNoFormatoBR) {
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}
/*rgb(71 130 180)*/
.gray-row {
  background-color: rgb(
    71 130 180
  ); /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
